import { Pipe, PipeTransform } from '@angular/core';

/**
 * Deixa maiúscula a PRIMEIRA letra do texto, sem mexer no resto.
 *
 * Existe por causa das datas por extenso em português: "segunda-feira, 24 de
 * agosto de 2026" vem toda em minúsculas, porque no idioma dia da semana e mês
 * não levam maiúscula — falta só a inicial da frase. Em inglês a data já vem
 * capitalizada e o pipe não muda nada.
 *
 * Por que aqui e não no CSS: `::first-letter { text-transform: uppercase }`
 * resolveria na tela, mas o texto continuaria minúsculo no HTML gerado — e
 * quem copia, exporta ou lê o arquivo veria o texto errado.
 */
@Pipe({ name: 'capitalizeFirst' })
export class CapitalizeFirstPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) { return value; }
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
